import React from "react";

const Sidebar = ({ onSelect }) => {
  const styles = {
    sidebar: {
      width: "200px",
      backgroundColor: "#1e1e2f",
      height: "100vh",
      color: "#fff",
      padding: "20px",
    },
    item: {
      margin: "10px 0",
      cursor: "pointer",
    },
  };

  const items = [
    "Dashboard",
    "Stores",
    "Customers",
    "Orders",
    "Deals",
    "SearchHistory",
    "Earnings", // ✅ Added here
  ];

  return (
    <div style={styles.sidebar}>
      <h2>Admin Panel</h2>
      {items.map((item) => (
        <div
          key={item}
          style={styles.item}
          onClick={() => onSelect(item)}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
